import { PaletteOptions } from "@mui/material";

export const palette: PaletteOptions = {
  common: {
    white: "#fff",
    black: "#000",
  },
  primary: {
    main: "#001a71",
    light: "#D6DAF9",
    dark: "#5A75FF",
  },
  secondary: {
    main: "#5f6a82",
    light: "#707689",
    dark: "#686B6D",
  },
  text: {
    primary: "#000000",
    secondary: "#505B7D",
    disabled: "#B7BCCC",
  },
  info: {
    main: "#001a71",
    light: "#D6DAF9",
    dark: "#5A75FF",
  },
  success: {
    main: "#61CC71",
    light: "#C0EBC6",
    dark: "#4EA35A",
  },
  warning: {
    main: "#FFCC00",
    light: "#FDEDBB",
    dark: "#E6B95D",
  },
  error: {
    main: "#c9493d",
    light: "#FF4D3D",
    dark: "#CC3E31",
  },
  background: {
    default: "#F5F4F7",
    paper: "#FFFFFF",
  },
  divider: "#F5F4F7",
  grey: {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161",
  },
  sectionBackground: {
    primary: "#fff",
    secondary: "transparent",
  },
  typography: {
    headingXLarge: "#000",
    headingLarge: "#212529",
    headingMedium: "#000",
    subtitle: "#000",
    body: "#686B6D",
    bodyMedium: "#000",
    bodyBold: "#000",
    small: "#000",
    smallMedium: "#000",
    xsmall: "#000",
    link: "#001a71",
    disclaimer: "#686B6D",
    listItem: {
      primary: "#212529",
      secondary: "#5f6a82",
    },
  },
  checkbox: {
    default: "#001a71",
  },
  footer: {
    backgroundColor: {
      desktop: "#FFFFFF",
      mobile: "#FFFFFF",
    },
    color: {
      desktop: "#686B6D",
      mobile: "#686B6D",
    },
  },
  alertWidget: {
    success: {
      backgroundColor: "#DFF5E3",
      color: "#000",
    },
    error: {
      backgroundColor: "#FEE4E1",
      color: "#000",
    },
    warning: {
      backgroundColor: "#FFF5E1",
      color: "#000",
    },
    info: {
      backgroundColor: "#DEE3FF",
      color: "#000",
    },
  },
  buttons: {
    primary: {
      default: {
        backgroundColor: "#001a71",
        borderColor: "#001a71",
        color: "#FFFFFF",
        borderRadius: "28px",
      },
      hover: { backgroundColor: "#4c5e9b", borderRadius: "28px" },
      disabled: { backgroundColor: "#B7BCCC", color: "#5f6a82" },
    },
    secondary: {
      default: {
        backgroundColor: "#b8c6e1",
        borderColor: "#b8c6e1",
        color: "#001a71",
        borderRadius: "28px",
      },
      hover: {
        backgroundColor: "#B7BCCC",
        borderColor: "#B7BCCC",
        color: "#5f6a82",
        borderRadius: "28px",
      },
    },
    text: { default: { color: "#5d6880" } },
  },
};
